import { AutocompleteInput } from '@kirz/mui-admin';
import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import React, { useContext } from 'react';

import { UserContext } from 'contexts/UserContext';
import { api } from 'services/api';
import { Client } from 'types/user';

export function UserCompanySelector() {
  const { user } = useContext(UserContext);

  if (user.role !== 'client') {
    return null;
  }

  const client = user as Client;
  if (!client.identities?.length || client.identities.length <= 1) {
    return null;
  }

  return (
    <FormControl sx={{ mr: 2 }} size="small">
      <InputLabel id="identity-select-label">Bedrijf</InputLabel>
      <Select
        label="Bedrijf"
        sx={{ width: '200px' }}
        size="small"
        labelId="identity-select-label"
        value={user.id}
        onChange={async (e) => {
          await api.login({
            email: user.email,
            identityId: e.target.value,
          } as any);
          window.location.reload();
        }}
      >
        {client.identities.map((identity) => (
          <MenuItem key={identity.id} value={identity.id}>
            {identity.userName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
